import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { resetQuickViewId } from '~/app/store/debug/actions'
import { ThunkDispatch } from '~/app/store/interface'
import { tileEntityByIdSelector } from '~/app/store/tileEntity'

export const useValidQuickViewEntity = (designId?: string | null) => {
  const dispatch = useDispatch<ThunkDispatch>()
  const tileEntityById = useSelector(tileEntityByIdSelector)

  useEffect(() => {
    if (!designId) {
      return
    }

    const tileEntity = tileEntityById(designId)
    if (!tileEntity) {
      dispatch(resetQuickViewId())
      return
    }

    const url = new URL(window.location.href)
    if (url.searchParams.has('qv')) {
      return
    }

    // remove "/qv/${designId}"
    if (url.pathname.includes('/qv/')) {
      url.pathname = url.pathname.split('/qv/')[0]
    }

    // remove "?quickView=${designId}"
    if (url.searchParams.has('quickView')) {
      url.searchParams.delete('quickView')
    }

    // set QV to "path?qv=${designId}"
    url.searchParams.set('qv', designId)

    window.history.replaceState(null, '', url.toString())
  }, [dispatch, designId, tileEntityById])

  if (designId && tileEntityById(designId)) {
    return tileEntityById(designId)
  }

  return null
}
